import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/catalyst/button";
import { AlertDialog } from "@/lib/Components/Dialog/AlertDialog";
import {
  AlertActions,
  AlertDescription,
  AlertTitle,
} from "@/components/catalyst/alert";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { applySupplierAgeRequirementsToVehiclesMutation } from "@/app/Suppliers/GraphQL/supplierMutations";

export function ApplyAgeRequirementsToVehiclesDialog({
  supplierId,
}: {
  supplierId: string;
}) {
  const { close, resolve, reject } = useDialogState();
  const [isLoading, setIsLoading] = useState(false);
  const { mutateAsync } = useGqlMutation(
    applySupplierAgeRequirementsToVehiclesMutation,
  );

  return (
    <AlertDialog
      onClose={() => {
        reject?.(false);
      }}
    >
      <AlertTitle>Apply to all vehicles?</AlertTitle>
      <AlertDescription>
        This will overwrite the age requirements on every vehicle for this
        supplier with the values you just saved.
      </AlertDescription>
      <AlertActions>
        <Button
          outline
          onClick={() => {
            close();
            reject?.(false);
          }}
        >
          Cancel
        </Button>
        <Button
          isLoading={isLoading}
          onClick={async () => {
            try {
              setIsLoading(true);
              await mutateAsync({ supplierId });
              toast.success("Age requirements applied to all vehicles");
              await close();
              resolve?.(true);
            } finally {
              setIsLoading(false);
            }
          }}
        >
          Apply to all vehicles
        </Button>
      </AlertActions>
    </AlertDialog>
  );
}
